import type { CSSProperties } from 'react'

const fonts = {
  ibmPlaex: '--font-ibm-plaex',
} as const

const typography: TypeStyles = {
  'font-ibm-plaex': {
    'font-family': `var(${fonts.ibmPlaex})`,
    'font-style': 'normal',
    'font-weight': 400,
    'line-height': '100%',
    'letter-spacing': '-0.03em',
    'font-size': { mobile: 10, desktop: 10 },
    'text-transform': 'uppercase',
  },
  cta: {
    'font-family': `var(${fonts.ibmPlaex})`,
    'font-style': 'normal',
    'font-weight': 400,
    'line-height': '140%',
    'font-feature-settings': '"case"',
    'font-size': { mobile: 16, desktop: 16 },
  },
  p: {
    'font-family': `var(${fonts.ibmPlaex})`,
    'font-style': 'normal',
    'font-weight': 400,
    'line-height': '100%',
    'letter-spacing': '-0.03em',
    'font-feature-settings': '"case"',
    'font-size': { mobile: 10, desktop: 10 },
  },
  'p-l': {
    'font-family': `var(${fonts.ibmPlaex})`,
    'font-style': 'normal',
    'font-weight': 500,
    'line-height': '140%',
    'letter-spacing': '-0.03em',
    'font-size': { mobile: 20, desktop: 20 },
  },
  terminal: {
    'font-family': `var(${fonts.ibmPlaex})`,
    'font-style': 'normal',
    'font-weight': 400,
    'line-height': '140%',
    'letter-spacing': '-0.03em',
    'font-size': { mobile: 12, desktop: 14 },
  },
  h4: {
    'font-family': `var(${fonts.ibmPlaex})`,
    'font-style': 'normal',
    'font-weight': 500,
    'line-height': '140%',
    'letter-spacing': '-0.06em',
    'font-size': { mobile: 30, desktop: 50 },
  },
} as const

export { fonts, typography }

// UTIL TYPES
type TypeStyles = Record<
  string,
  {
    'font-family': string
    'font-style': CSSProperties['fontStyle']
    'font-weight': CSSProperties['fontWeight']
    'line-height':
      | `${number}%`
      | { mobile: `${number}%`; desktop: `${number}%` }
    'letter-spacing'?:
      | `${number}em`
      | { mobile: `${number}em`; desktop: `${number}em` }
    'font-feature-settings'?: string
    'font-size': number | { mobile: number; desktop: number }
    'text-transform'?: CSSProperties['textTransform']
  }
>
